import script from "./resetPasswordPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./resetPasswordPopup.vue?vue&type=script&setup=true&lang=ts"

import "./resetPasswordPopup.vue?vue&type=style&index=0&id=3f41f722&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f41f722"]])

export default __exports__